import {
  getPublicDealsPath,
  getPublicDealsRetailer,
} from "../config/publicDeals";
import { sanitizePublicDealsReturnTo } from "../utils/authReturn";

export function getAuthenticatedOnlineDealsPath(slug: string, search = "") {
  const retailer = getPublicDealsRetailer(slug);
  if (!retailer) return undefined;
  const routeRetailer = retailer.apiRetailer
    .replace("walmart_online", "walmart")
    .replace("target_online", "target");
  const safeReturnTo = sanitizePublicDealsReturnTo(
    `${getPublicDealsPath(retailer.slug)}${search}`
  );
  const sourceParams = safeReturnTo
    ? new URL(safeReturnTo, "https://dealhawk.invalid").searchParams
    : new URLSearchParams();
  const targetParams = new URLSearchParams({ storeId: "online" });
  sourceParams.forEach((value, key) => targetParams.set(key, value));
  return `/${routeRetailer}/products?${targetParams.toString()}`;
}
